var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.child_component,{ref:"CrewAlertsManageCreationChild",tag:"component",attrs:{"crew_alert":_vm.crew_alert,"users":_vm.users,"constants":_vm.constants,"valuelists":_vm.valuelists,"is_preview":true,"preview_request":_vm.preview_request},on:{"view":_vm.changeView,"response-received":_vm.submissionResponseReceived}})
}
var staticRenderFns = []

export { render, staticRenderFns }